import React from "react";
import { Proficiency } from "components/pages/Educator/Proficiency/Proficiency";

export const AdminProficiency = ({ selectedEducator, sharedClassId, onClassChange }) => {
  if (!selectedEducator) return null;
  return (
    <Proficiency
      key={selectedEducator.id}
      educatorId={selectedEducator.id}
      sharedClassId={sharedClassId}
      onClassChange={onClassChange}
    />
  );
};
